enum PillStyle {
  DEFAULT = 'default',
  CHIP = 'chip',
}

enum PillType {
  SOLID = 'solid',
  OUTLINE = 'outline',
}
export { PillStyle, PillType };
